import { createDrawingObject, replaceLastPoint } from "../shared";
import { toOverlayPrimitive } from "../overlayPrimitiveAdapter";
import { hitTestOverlayPrimitive, renderOverlayPrimitiveToCanvas } from "@vninvestcharts/engine-core";
function renderDatePriceRange(ctx, drawing, scales, options) {
    const primitive = toOverlayPrimitive(drawing, scales, {
        chartWidth: options.chartWidth,
        chartHeight: options.chartHeight,
    });
    if (primitive) {
        renderOverlayPrimitiveToCanvas(ctx, primitive, options);
    }
}
function hitTestDatePriceRange(drawing, point, scales, tolerance) {
    const primitive = toOverlayPrimitive(drawing, scales);
    if (!primitive)
        return false;
    return hitTestOverlayPrimitive(primitive, point.pixelX, point.pixelY, { tolerance, chartWidth: 800, chartHeight: 600 });
}
const DatePriceRange = {
    name: "datePriceRange",
    createDraft: (startPoint) => createDrawingObject("datePriceRange", [startPoint, startPoint], {
        style: { stroke: "#00E676", strokeWidth: 1 },
    }),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
    hitTest: hitTestDatePriceRange,
};
export default DatePriceRange;
